import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

import { PaginatorComponent } from './paginator.component';

import { SelectModule } from '@iss/core/select';

@NgModule({
  imports: [ SelectModule, NgIf, AsyncPipe, FormsModule, PaginatorComponent ],
  exports: [ PaginatorComponent ],
})
export class PaginatorModule {}
